





























import { Component, Vue, Prop } from 'vue-property-decorator';

import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import { FilledButton } from '@/components/molecules';
import eventBus from '@/utils/eventBus';
import Loading from '@/components/icons/Loading.vue';

@Component({
  components: {
    SelectorAndList,
    FilledButton,
    Loading
  }
})
export default class BusinessKeywords extends Vue {
  @Prop({ required: true }) data!: any;

  searchText = '';

  service = new AdminService();

  loading = false;
  loadingSubmit = false;

  keywords: any[] = this.mapKeywords(this.data.keywords || []);
  keywordsOptions: any[] = [];

  linkedKeywordsIds: string[] = [];

  closeModal() {
    if (this.data.close) {
      this.data.close();
    }
  }

  addKeyword() {
    if (!this.searchText.trim()) return;

    this.keywords.push({ label: this.searchText, new: true });

    this.searchText = '';
    eventBus.$emit('clearAutocomplete');
  }

  async searchKeywords(search: string) {
    try {
      this.searchText = search;

      const { data } = await this.service.getKeywords({
        pagination: '',
        sortField: '',
        sortOrder: '',
        filters: `keywordName=${search}`
      });
      const selectedIds = new Set(this.keywords.map(c => c.id));
      this.keywordsOptions = this.mapKeywords(
        data.items
          .map((item: any) => item.keyword)
          .filter((item: any) => !selectedIds.has(item.id))
      );
    } catch (e) {
      this.keywordsOptions = [];
      this.$notification(treatError(e));
    }
  }

  mapKeywords(keywords: any[] = []) {
    return keywords.map(keyword => {
      return {
        ...keyword,
        label: keyword.name
      };
    });
  }

  async submit() {
    try {
      this.loadingSubmit = true;
      const newKeywords = this.keywords.filter(item => !!item.new);
      let newKeywordsIds = [];

      if (newKeywords.length) {
        const { data } = await this.service.createKeywords(
          newKeywords.map(item => item.label)
        );
        newKeywordsIds = data.data;
      }

      const withoutLinkKeywords = this.keywords
        .filter(item => !item.new && !this.linkedKeywordsIds.includes(item.id))
        .map(item => item.id);

      const deletedKeywordsIds = this.linkedKeywordsIds.filter(
        id => !this.keywords.map(keyword => keyword.id).includes(id)
      );
      const createdKeywordsIds = [...withoutLinkKeywords, ...newKeywordsIds];

      const promises: any = [
        ...(deletedKeywordsIds.length
          ? deletedKeywordsIds.map(id =>
              this.service.deleteKeywordByBusiness(this.data.id, id)
            )
          : []),
        createdKeywordsIds.length &&
          this.service.createKeywordByBusiness(this.data.id, createdKeywordsIds)
      ];
      await Promise.all(promises);

      this.$notification('Success');
      this.closeModal();
    } catch (e) {
      this.$notification(treatError(e));
    } finally {
      this.loadingSubmit = false;
    }
  }

  async created() {
    try {
      this.loading = true;
      const { data } = await this.service.getKeywordsByBusiness(this.data.id);
      this.keywords = data.data.map((item: any) => ({
        ...item,
        label: item.name
      }));
      this.linkedKeywordsIds = data.data.map((item: any) => item.id);
    } finally {
      this.loading = false;
    }
  }
}
